export const FILENAME_REPLACE_REGEXP = /[\r\n?"#$^:;<>|%*@'~&\\/]/g
export const STREAM_REPLACE_REGEXP = /[\r\n?"#$^:;<>|%*@'~&\\/]/g

export const S3_FILENAME_REPLACE_REGEXP = /[\r\n?"#$^:;—<>|%*+@'~&\\/]/g
export const S3_FILENAME_ALLOWED_SYMBOLS = /^(?=.{3,255}$)[a-zа-я0-9-_.!*'()]+$/i
